import React from 'react';
import {
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Icon,
} from '../../../../base';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from '../../../../routes/RoutePaths';
import UserPreview from '../../UserPreview';
import { getSideMenuItems } from '../consts.SideMenu';
import {
    LogoContainer,
    StyledLogo,
    StyledListItemIcon,
} from './SideMenuMobile.styles';
import { ISideMenuItem } from '../interfaces.SideMenu';
import { useTranslation } from 'react-i18next';
import { useAppSelector, RootState } from '../../../../base';
import { organizationSelectors } from '../../../../actions';
import { FeatureFlags } from '../../../../common';

interface Props {
    onClose?: () => void;
}

const SideMenuMobile: React.FC<Props> = ({ onClose }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const isReportsFeatureFlagOn = useAppSelector((state: RootState) =>
        organizationSelectors.isFlagOn(state, FeatureFlags.REPORTS)
    );
    const featureFlags = {
        [FeatureFlags.REPORTS]: isReportsFeatureFlagOn,
    };

    const handleNavigate = (path: string) => {
        if (path && path in RoutePaths) {
            navigate(RoutePaths[path as keyof typeof RoutePaths]);
            onClose?.();
        }
    };

    return (
        <Box
            sx={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
        >
            <LogoContainer>
                <StyledLogo src="/assets/fullTextLogo.svg" alt="Logo" />
            </LogoContainer>
            <List sx={{ flexGrow: 1, overflowY: 'auto' }}>
                {getSideMenuItems(t, featureFlags)
                    .filter((item) => !item.hide)
                    .map((item: ISideMenuItem) => (
                        <ListItem key={item.key} disablePadding>
                            <ListItemButton
                                onClick={() => handleNavigate(item.path)}
                            >
                                <StyledListItemIcon>
                                    <Icon name={item.iconName} size={24} />{' '}
                                    {/* Adjust icon size */}
                                </StyledListItemIcon>
                                <ListItemText primary={item.tooltipText} />
                            </ListItemButton>
                        </ListItem>
                    ))}
            </List>
            <Box
                sx={{
                    marginTop: 'auto',
                    padding: (theme) => theme.spacing(1),
                    borderTop: (theme) => `1px solid ${theme.palette.divider}`,
                }}
            >
                <UserPreview />
            </Box>
        </Box>
    );
};

export default SideMenuMobile;
